import React from 'react'
// @ts-ignore no types
import * as graph from '@adc/sdk'
import type { Maybe } from '@adc/sdk/types'
import type {
  AuctionBlueprintOnlineReactiveArgs,
  AuctionBlueprintScheduledOnlineReactiveArgs,
  primitives,
} from '@adc/blueprint'
import type { FeatureFlags } from '@adc/ui-adc'
import BidAgain from 'common/modules/bidBanner/bidAgain'
import { useListingContext } from 'common/context/listing'
// @ts-ignore no types
import { Before, During, After } from './states'
type AuctionUser = primitives.AuctionUser

const hideReoPostBidBoxListingStatuses = [
  graph.enums.ListingStatus.Canceled,
  graph.enums.ListingStatus.SaleGatekeeping,
  graph.enums.ListingStatus.NoSale,
  graph.enums.ListingStatus.InClosing,
]
export const shouldShowBanner = (
  segment: Maybe<AuctionBlueprintScheduledOnlineReactiveArgs['segment']>,
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
): boolean => {
  const showPostBidBox =
    segment?.segment_status === graph.enums.OnlineAuctionSegmentStatus.Ended &&
    !hideReoPostBidBoxListingStatuses.includes(listing?.listing_status)

  if (
    (!listing?.is_current_user_registered_for_online_auction &&
      !(
        segment?.current_user_bidding_status ===
        graph.enums.OnlineAuctionSegmentBiddingStatus.Won
      )) ||
    showPostBidBox
  ) {
    return false
  } else if (
    segment?.segment_status === graph.enums.OnlineAuctionSegmentStatus.Pending
  ) {
    // TODO: This should come from the segment, not the listing.
    return Boolean(
      listing.is_current_user_registered_for_online_auction &&
        listing.listing_configuration?.is_proxy_bidding_enabled
    )
  } else {
    return true
  }
}

export interface BidBannerProps {
  featureFlags: FeatureFlags
  user: AuctionUser
  similarProperties?: object[]
  refreshCurrentListing: () => void
}

export default function BidBanner(props: BidBannerProps) {
  const { segment, listing } = useListingContext()
  const { featureFlags } = props

  if (!shouldShowBanner(segment, listing)) {
    return null
  } else {
    const bidDeposit =
      featureFlags['fe.resi.enable-wallet'] &&
      listing.current_user_bid_deposit_requirements
        ?.is_registration_deposit_applicable
        ? listing.current_user_bid_deposit_requirements
            ?.absolute_amount_required
        : null

    if (
      segment?.segment_status === graph.enums.OnlineAuctionSegmentStatus.Pending
    ) {
      return (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        <Before {...props} bidDeposit={bidDeposit} />
      )
    } else if (segment?.__methods__.isOnlineAuctionActive()) {
      const shouldShowOneBidAway = segment.__methods__.shouldShowOneBidAway()
      const shouldShowTwoBidAway = segment.__methods__.shouldShowTwoBidAway()
      const isMinimumBidEnabled =
        listing.listing_configuration?.is_minimum_bid_enabled || false
      return (
        <>
          <BidAgain />
          <During
            {...props}
            shouldShowOneAwayMessage={
              shouldShowOneBidAway || isMinimumBidEnabled
            }
            shouldShowTwoAwayMessage={shouldShowTwoBidAway}
            bidDeposit={bidDeposit}
          />
        </>
      )
    } else {
      return <After {...props} bidDeposit={bidDeposit} />
    }
  }
}
